import React from 'react';

import HeaderNavComponent from '../header/HeaderNavComponent';
import FooterComponent from '../footer/FooterComponent';
import { BreadcrumbComponent } from '../breadcrumb/BreadcrumbComponent';

export const PrimaryTemplate = props => {
    return (
        <div className="template template-primary flex-container-v">
            <HeaderNavComponent hideNav={true} hideSearch={true} />
            {!props.hideBreadcrumb && <BreadcrumbComponent />}
            {props.children}
            <FooterComponent />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/template/PrimaryTemplate.js